export const buildTypesenseInFilter = (field, list) => `${field}: [${list.join(',')}]`;

export const TYPESENSE_CHUNK_SIZE = 100;

// Field that holds a task's client owner on each related index. The task
// assignee (`ownerDocId` on tasks) has no equivalent on clients/deals, so it is
// never carried over — the final tasks query re-applies it.
const CLIENT_OWNER_FIELD_BY_INDEX = {
	clients: 'ownerDocId',
	deals: 'clientOwnerDocId',
};

/**
 * Translates a tasks-index filter string into the broker group / client owner
 * scope for a related `indexName` ('clients' or 'deals').
 */
export const extractOwnerAndBrokerFilters = (filters, indexName) => {
	if (!filters) return '';

	const clauses = [];

	const clientOwnerList = filters.match(/clientOwnerDocId:\s*(\[[^\]]*\])/);
	const clientOwnerField = CLIENT_OWNER_FIELD_BY_INDEX[indexName];

	const brokerList = filters.match(/brokerGroupId:\s*\[[^\]]*\]/);
	const brokerEq = filters.match(/brokerGroupId\s*:?=\s*[^\s&]+/);

	if (clientOwnerList && clientOwnerField) {
		clauses.push(`${clientOwnerField}: ${clientOwnerList[1]}`);
	}

	if (brokerList) {
		clauses.push(brokerList[0]);
	} else if (brokerEq) {
		clauses.push(brokerEq[0]);
	}

	return clauses.join(' && ');
};
